import { useEffect, useMemo, useState } from 'react'
import debounce from 'lodash.debounce'
import type { GoogleAutocompletePlaceItem } from 'api/search'
import { getAutocompleteSuggestions } from 'api/search'

const SEARCH_DEBOUNCE_MS = 500

export default function useAgentHubAddressAutocomplete(textInput: string) {
  const [predictions, setPredictions] = useState<Array<GoogleAutocompletePlaceItem>>([])
  const [isLoading, setIsLoading] = useState(false)

  const debouncedGetAutocompleSuggestions = useMemo(() => debounce((textInput: string) => {
    if (!textInput) {
      return
    }
    getAutocompleteSuggestions(textInput).then(setPredictions)
      .finally(() => setIsLoading(false))
  }, SEARCH_DEBOUNCE_MS), [])

  useEffect(() => {
    setIsLoading(true)
    debouncedGetAutocompleSuggestions(textInput)
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [textInput])

  return {
    predictions,
    isLoading,
  }
}
